module.exports = __webpack_public_path__ + "img/Step3.9f2eac3.svg";